import { useQuery } from "@tanstack/react-query";
import { GET_TAXONOMY_OPTIONS_QUERY_KEY } from "../utils/constants/queryKeys";
import { TAXONOMY_OPTIONS_STALE_MS } from "../utils/constants/AdIntelligence";
import useAxiosPrivate from "./useAxiosPrivate";
import CreativeAnalysisAPIs from "../apiRoutes/CreativeAnalysis";

/** Closed sets for every category; with a category, also its approved vocabulary. */
const useTaxonomyOptions = ({ category = "", enabled = true } = {}) => {
  const axiosPrivate = useAxiosPrivate();
  return useQuery({
    queryKey: [...GET_TAXONOMY_OPTIONS_QUERY_KEY, category],
    queryFn: () =>
      CreativeAnalysisAPIs.handleGetTaxonomyOptions({ axiosPrivate, category }),
    staleTime: TAXONOMY_OPTIONS_STALE_MS,
    enabled,
  });
};

export default useTaxonomyOptions;
